import { Box, Button, Grid } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";
import {
  iObjetivoAprendizaje,
  SelectedIndicator,
} from "../../interfaces/ObjetivosAprendizaje/iObjetivosAprendizaje";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";

interface Props {
  handleToggleAllIndicators: (
    idObjetivo: string,
    allIndicators: string[]
  ) => void;
  objetivo: iObjetivoAprendizaje;
  allSelected: boolean;
  handleRemoveObjectiveFromProject: (objetivo: iObjetivoAprendizaje) => void;
  handleAddObjectiveToProject: (objetivo: iObjetivoAprendizaje) => void;
  hasSelectedIndicator: boolean;
  setSelectedIndicators: Dispatch<SetStateAction<SelectedIndicator>>;
  color: string;
}

const SelectButtons: FC<Props> = ({
  handleToggleAllIndicators,
  objetivo,
  allSelected,
  handleRemoveObjectiveFromProject,
  handleAddObjectiveToProject,
  hasSelectedIndicator,
  setSelectedIndicators,
  color,
}) => {
  const { objetivosSeleccionados } = useActividadesContext();

  const isSelected = objetivosSeleccionados[objetivo.id_objetivo] ?? false;

  const handleToggleAll = () =>
    handleToggleAllIndicators(objetivo.id_objetivo, objetivo.indicadores);

  const handleToggleObjective = () => {
    isSelected
      ? handleRemoveObjectiveFromProject(objetivo)
      : handleAddObjectiveToProject(objetivo);
  };

  const hasIndicadores =
    Array.isArray(objetivo.indicadores) && objetivo.indicadores.length > 0;

  const isActionDisabled = hasIndicadores
    ? !isSelected && !hasSelectedIndicator
    : false;

  const actionButtonText = isSelected ? "Eliminar" : "Agregar";
  const actionButtonColor = isSelected ? "#D00416" : "#1FC16B";
  const actionButtonHover = isSelected ? "#ff0015ff" : "#27d879ff";

  return (
    <Grid
      container
      display="flex"
      flexDirection="row"
      justifyContent="end"
      alignItems="center"
    >
      {hasIndicadores && (
        <Box mt={4} mb={1}>
          <Button
            variant="text"
            onClick={handleToggleAll}
            sx={{ fontSize: "10px", color }}
          >
            {allSelected ? "Deseleccionar todos" : "Seleccionar todos"}
          </Button>
        </Box>
      )}

      <Box textAlign="center" mt={1}>
        <Button
          variant="contained"
          onClick={handleToggleObjective}
          disabled={isActionDisabled}
          sx={{
            mt: 2,
            borderRadius: "20px",
            backgroundColor: actionButtonColor,
            "&:hover": { backgroundColor: actionButtonHover },
          }}
        >
          {actionButtonText}
        </Button>
      </Box>
    </Grid>
  );
};

export default SelectButtons;
